import type { CategoryMeta, FeaturedSlide } from '@/types/video';

export const categories: CategoryMeta[] = [
  {
    key: 'movie',
    name: '电影',
    icon: 'ri-film-line',
    desc: '院线新片与经典佳作，动作、悬疑、科幻一站看齐',
    path: '/category/movie',
  },
  {
    key: 'tv',
    name: '电视剧',
    icon: 'ri-tv-2-line',
    desc: '国产好剧与海外热播，悬疑权谋、都市情感全都有',
    path: '/category/tv',
  },
  {
    key: 'variety',
    name: '综艺',
    icon: 'ri-mic-line',
    desc: '音综、真人秀、美食竞技，一起笑到停不下来',
    path: '/category/variety',
  },
];

export const featuredSlides: FeaturedSlide[] = [
  { id: 'ht-m7', tagline: '云海之上，藏着一段不能被唤醒的往事', label: '年度科幻巨制' },
  { id: 'ht-t1', tagline: '十二年悬案重启，真相藏在每一个雨夜', label: '高分悬疑剧集' },
  { id: 'ht-v1', tagline: '让好歌被更多人听见，今晚舞台为你点燃', label: '热播音乐综艺' },
  { id: 'ht-m2', tagline: '在孤独的深空里，回家的路只有一条', label: '视听双绝大片' },
];

export const hotSearchKeywords: string[] = [
  '悬疑',
  '科幻',
  '高分电影',
  '国产剧',
  '综艺',
  '动作',
  '治愈',
  '音乐',
  '爱情',
  '4K HDR',
];

export const regionOptions: string[] = [
  '全部',
  '中国大陆',
  '中国香港',
  '美国',
  '英国',
  '韩国',
  '日本',
  '德国',
];

export const yearOptions: string[] = ['全部', '2025', '2024', '2023', '2022', '2021', '2020'];